export const parseErrorCodeToi18nKey = (errorCode: string): string => errorCode.split('.').join('')
